import { render } from "./toolbarHeader.vue?vue&type=template&id=773271b8&scoped=true"
import script from "./toolbarHeader.vue?vue&type=script&lang=js"
export * from "./toolbarHeader.vue?vue&type=script&lang=js"

import "./toolbarHeader.vue?vue&type=style&index=0&id=773271b8&lang=scss&scoped=true"
import "./toolbarHeader.vue?vue&type=style&index=1&id=773271b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773271b8"]])

export default __exports__